export default {
  site_name: "精品视频",
  site_slogan: "高清优质内容一站畅享",
  home: "首页",
  categories: "分类",
  about: "关于我们",
  all_categories: "全部分类",
  view_all: "查看全部",
  featured_videos: "精选推荐",
  hot_videos: "热门视频",
  latest_articles: "最新文章",
  platform_features: "平台特色",
  faq_title: "常见问题",
  read_more: "阅读全文",
  watch_now: "立即观看",
  learn_more: "了解更多",
  contact_us: "联系我们",
  brand_intro: "品牌介绍",
  reputation: "信誉展示",
  home_breadcrumb: "首页",
  category_breadcrumb: "分类",
  article_breadcrumb: "文章",
  about_breadcrumb: "关于我们",
  views: "次观看",
  duration: "时长",
  rating: "评分",
  back_to_home: "返回首页",
  no_videos: "暂无视频",
  category_videos: "分类视频",
  published_on: "发布于",
  author: "作者",
  tags: "标签",
  related_articles: "相关文章",
  hero_title: "精品视频汇聚海量高清内容",
  hero_subtitle: "高清影视、教育、娱乐内容，画质清晰、更新及时、分类精准",
  hero_cta: "立即免费体验",
  feature_hd: "高清画质",
  feature_hd_desc: "支持720P至4K超高清画质，顶级视觉体验",
  feature_update: "极速更新",
  feature_update_desc: "热播内容2小时内上线，紧跟最新动态",
  feature_category: "精准分类",
  feature_category_desc: "八大分类精准导航，快速找到想看的内容",
  feature_multi: "多端同步",
  feature_multi_desc: "电脑、手机、平板、电视全平台无缝切换",
  brand_story_title: "关于精品视频",
  brand_story: "精品视频成立于2020年，是一家专注于高清视频内容聚合与分发的互联网平台。我们致力于为全球华语用户提供最优质的视频观看体验，汇聚了来自全球顶尖内容制作方的影视、教育、娱乐资源。经过四年的发展，精品视频已累计服务超过5000万用户，平台内容库超过10万小时，日均活跃用户超过300万。我们的使命是让每一个人都能随时随地享受顶级的视觉体验。",
  reputation_title: "平台信誉",
  reputation_items: [
    { label: "服务用户", value: "5000万+" },
    { label: "内容时长", value: "10万+小时" },
    { label: "合作方", value: "200+" },
    { label: "日活用户", value: "300万+" },
  ],
  contact_title: "联系方式",
  contact_address: "北京市朝阳区建国路88号SOHO现代城A座18层",
  contact_phone: "+86 10-8888-6666",
  contact_email: "contact@jingpinshipin.com",
  contact_wechat: "精品视频官方",
  copyright: "© 2024 精品视频 版权所有",
  beian: "京ICP备2024000001号",
  scroll_top: "回到顶部",
  category_all: "全部",
  search_placeholder: "搜索视频、文章...",
  article_page_title: "文章详情",
  related_videos: "相关视频",
  page_not_found: "页面未找到",
  page_not_found_desc: "您访问的页面不存在或已被移除",
};